<template>
    <div class="n2-center-container">
        <div class="n2-text-center">
            <h5>{{$t('pages.account.index.title')}}</h5>
        </div>
        <div id="n3-account-index">
            <div class="n2-row">
                <div class="col-md-4 n2-padding">
                    <ul>
                        <li>
                            <router-link v-bind:to="`/${app_locale}/admin/orders`">{{$t('pages.admin.index.orders')}}</router-link>
                        </li>
                        <!-- <li>
                            <router-link v-bind:to="`/${app_locale}/admin/contents`">{{$t('pages.admin.index.contents')}}</router-link>
                        </li> -->
                    </ul>
                </div>
                <div class="col-md-8 n2-padding">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'



    export default {
        data: function () {
            return {
            }
        },
        computed: {

            ...mapGetters('globalization', [
                'app_locale',
            ])
        },

        created: function () {
        },
        mounted: async function () {
        },
        methods: {
        }
    }
</script>
